module.exports = __webpack_public_path__ + "img/18.81dfc31.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/18.png
// module id = drFX
// module chunks = 1